import { createSelector } from 'reselect';
import _ from 'lodash';

export const selectUserState = state => _.get(state, 'user');

export const selectUserSubscriptions = createSelector(
  [selectUserState],
  user => {
    const subs = _.get(user, 'subscriptions', []);
    return subs;
  },
);

export const selectUserIsLoggedIn = state => {
  const isLoggedIn = _.get(state, 'user.userhash', null);
  return !!isLoggedIn;
};

export const selectUserProviders = () =>
  createSelector(
    [selectUserSubscriptions, selectUserIsLoggedIn],
    (userSubscriptions, isLoggedIn) => {
      const subs = userSubscriptions.map(provsub => {
        let userType = 'anonymous';
        if (isLoggedIn) {
          userType = provsub ? 'susc' : 'no_susc';
        }

        return {
          provider: provsub,
          type: userType,
        };
      });
      return subs;
    },
  );

export const selectLabelConfig = provider =>
  createSelector(
    [],
    (providersConfig, userType) => {
      let config = providersConfig[userType];
      config =
        config[provider] || config[provider.toLowerCase()] || config.default;

      return config;
    },
  );

/*
<Comp> formar arreglo con el tipo de usuario por proveedor 
{
  proveedor: susc || no_susc || anonymous
}

</COMp>
*/
